export default __webpack_public_path__ + "static/media/p6.bad0b783.jpg";